"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleEmptyList = useHandleEmptyList;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var CreateButton_1 = __importDefault(require("@components/Buttons/CreateButton/CreateButton"));
var useCurrentLanguage_1 = require("./useCurrentLanguage");
var useHandleEmptyListTranslator_1 = require("./localisation/useHandleEmptyListTranslator");
// Кастомный хук для обработки механиков
function useHandleEmptyList(_a) {
    var data = _a.data;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var currentLang = (0, useCurrentLanguage_1.useCurrentLanguage)();
    var loc = useHandleEmptyListTranslator_1.useHandleEmptyListTranslator[currentLang];
    if (!data || data.length === 0) {
        return ((0, jsx_runtime_1.jsxs)("div", { style: {
                display: "flex",
                gap: "20px",
                alignItems: "center",
            }, children: [(0, jsx_runtime_1.jsx)("span", { children: loc.message }), (0, jsx_runtime_1.jsx)(CreateButton_1.default, { title: loc.buttonText, action: function () { return navigate("new"); } })] }));
    }
    return null; // Если механики есть, ничего не рендерим (или можно вернуть другую логику)
}
